import React from 'react';
import { Link } from 'react-router-dom';
import Inventory2OutlinedIcon from '@mui/icons-material/Inventory2Outlined';

export default function Brand({ to = '/', compact = false }) {
  return <Link to={to} className="pp-brand" aria-label="ПрокатПрост">
    <span className="pp-brand-icon"><Inventory2OutlinedIcon /></span>
    {!compact && <span>ПрокатПрост<span className="pp-brand-dot">.</span></span>}
  </Link>;
}
